export const CouponPageModes = {
  NEW: 'new',
  EDIT: 'edit',
} as const;

export type CouponPageModesType =
  typeof CouponPageModes[keyof typeof CouponPageModes];
